import DashShell from "@components/common/DashShell";
import { IconScreen } from "@ucchub/ui";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <DashShell>
      <IconScreen
        title="404: Page not Found"
        description="Unfortunately this page either does not exist or was recently removed."
        buttonText="Go to Home"
        buttonOnClick={() => navigate("/")}
        icon="help-circle"
      />
    </DashShell>
  );
};

export default NotFound;
